<template>
	<div class="page config-page">
		<el-tabs v-model="activeTab" type="card" @tab-click="onTabClick">
			<!-- 基础配置 -->
			<el-tab-pane label="基础配置" name="basic">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="card-header">
						<span>基础信息</span>
					</div>
					<el-form :model="form" label-width="120px" style="max-width:640px">
						<el-form-item label="项目名称">
							<el-input v-model="form.projectName" maxlength="32" placeholder="展示在客户端与登录页"></el-input>
						</el-form-item>
						<el-form-item label="Logo 地址">
							<el-input v-model="form.logoUrl" placeholder="图片URL，留空使用默认"></el-input>
							<div v-if="form.logoUrl" style="margin-top:8px">
								<el-image :src="form.logoUrl" style="width:48px;height:48px" fit="cover"></el-image>
							</div>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" :loading="saving" @click="save">保存配置</el-button>
							<el-button @click="load">重新加载</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-tab-pane>

			<!-- 邮件服务 -->
			<el-tab-pane label="邮件服务" name="email">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="card-header">
						<span>SMTP 与注册安全</span>
					</div>
					<el-form :model="form" label-width="120px" style="max-width:640px">
						<el-form-item label="SMTP 服务器">
							<el-input v-model="form.emailHost" placeholder="如 smtp.qq.com"></el-input>
						</el-form-item>
						<el-form-item label="端口">
							<el-input v-model="form.emailPort" placeholder="465"></el-input>
						</el-form-item>
						<el-form-item label="账号">
							<el-input v-model="form.emailUsername" placeholder="发件邮箱/授权账号"></el-input>
						</el-form-item>
						<el-form-item label="密码/授权码">
							<el-input v-model="form.emailPassword" type="password" show-password
								placeholder="不修改请留空"></el-input>
						</el-form-item>
						<el-form-item label="发件人">
							<el-input v-model="form.emailFrom" placeholder="通常与账号一致"></el-input>
						</el-form-item>
						<el-form-item label="使用 SSL">
							<el-switch v-model="sslBool"></el-switch>
						</el-form-item>
						<el-form-item label="注册邮箱验证码">
							<el-switch v-model="mailCodeBool"></el-switch>
							<div class="form-tip">开启后注册需输入邮箱验证码;关闭则注册仅需图文验证码(始终开启,不受此开关影响)。忘记密码的重置流程始终需要邮箱验证码。</div>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" :loading="saving" @click="save">保存配置</el-button>
							<el-button @click="load">重新加载</el-button>
						</el-form-item>
					</el-form>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header">
						<span>邮件发送测试</span>
					</div>
					<el-form inline>
						<el-form-item label="接收邮箱">
							<el-input v-model="testTo" placeholder="输入一个邮箱地址"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="success" :loading="testing" @click="sendTest">发送测试邮件</el-button>
						</el-form-item>
					</el-form>
					<el-alert type="info" :closable="false" title="点击发送会使用上方 SMTP 配置向该地址发送一封测试邮件，用于验证配置是否正确。"></el-alert>
				</el-card>
			</el-tab-pane>

			<!-- 能量租赁 -->
			<el-tab-pane label="能量租赁" name="rent">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="card-header">
						<span>能量租赁（钱包展示）</span>
					</div>
					<el-form :model="form" label-width="120px" style="max-width:640px">
						<el-form-item label="介绍文案">
							<el-input type="textarea" :rows="6" v-model="form.rentNotice" maxlength="1000"
								placeholder="介绍能量租赁的作用与使用方法,展示在钱包的能量租赁页(留空使用内置默认文案)"></el-input>
						</el-form-item>
						<el-form-item label="平台链接">
							<el-input v-model="form.rentUrl" placeholder="能量租赁平台网址,如 https://xxx.com (留空则不显示入口)"></el-input>
						</el-form-item>
						<el-form-item label="服务地址">
							<el-input v-model="form.rentAddress" placeholder="租赁平台的 TRON 收款/服务地址(可选)"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" :loading="saving" @click="save">保存配置</el-button>
							<el-button @click="load">重新加载</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-tab-pane>

			<!-- 官网配置 -->
			<el-tab-pane label="官网配置" name="site">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="card-header">
						<span>官网首屏与 SEO</span>
					</div>
					<el-form :model="siteForm" label-width="120px" style="max-width:720px">
						<el-form-item label="首屏小标签">
							<el-input v-model="siteForm.heroBadge" maxlength="64" placeholder="如:新一代安全即时通讯"></el-input>
						</el-form-item>
						<el-form-item label="首屏主标题">
							<el-input v-model="siteForm.heroTitle" maxlength="128"></el-input>
						</el-form-item>
						<el-form-item label="首屏副标题">
							<el-input type="textarea" :rows="2" v-model="siteForm.heroSubtitle" maxlength="512"></el-input>
						</el-form-item>
						<el-form-item label="SEO 标题">
							<el-input v-model="siteForm.seoTitle" maxlength="128" placeholder="浏览器标签页标题"></el-input>
						</el-form-item>
						<el-form-item label="SEO 关键词">
							<el-input v-model="siteForm.seoKeywords" maxlength="512" placeholder="英文逗号分隔"></el-input>
						</el-form-item>
						<el-form-item label="SEO 描述">
							<el-input type="textarea" :rows="2" v-model="siteForm.seoDescription" maxlength="512"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" :loading="siteSaving" @click="saveSite">保存官网配置</el-button>
							<el-button @click="loadSite">重新加载</el-button>
						</el-form-item>
					</el-form>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header">
						<span>客服联系方式(官网悬浮客服按钮)</span>
					</div>
					<el-form :model="siteForm" label-width="120px" style="max-width:720px">
						<el-form-item label="在线客服链接">
							<el-input v-model="siteForm.serviceUrl" placeholder="点击客服按钮打开的地址,如企微/客服系统链接(可空)"></el-input>
						</el-form-item>
						<el-form-item label="客服微信">
							<el-input v-model="siteForm.serviceWechat" placeholder="微信号(可空)"></el-input>
						</el-form-item>
						<el-form-item label="客服 QQ">
							<el-input v-model="siteForm.serviceQq" placeholder="QQ号(可空)"></el-input>
						</el-form-item>
						<el-form-item label="客服电话">
							<el-input v-model="siteForm.servicePhone" placeholder="如 400-xxx-xxxx(可空)"></el-input>
						</el-form-item>
						<el-form-item label="服务时间">
							<el-input v-model="siteForm.serviceTime" placeholder="如:周一至周日 9:00 - 23:00"></el-input>
						</el-form-item>
					</el-form>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header card-header-row">
						<span>客户端下载</span>
						<el-button type="primary" icon="el-icon-plus" size="small" @click="addSiteRow('downloads')">新增平台</el-button>
					</div>
					<el-table :data="siteForm.downloads" border size="small">
						<el-table-column label="平台标识" width="130">
							<template slot-scope="scope">
								<el-select v-model="scope.row.platform" size="mini">
									<el-option label="windows" value="windows"></el-option>
									<el-option label="mac" value="mac"></el-option>
									<el-option label="android" value="android"></el-option>
									<el-option label="ios" value="ios"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="名称" min-width="150">
							<template slot-scope="scope">
								<el-input v-model="scope.row.name" size="mini" placeholder="Windows 客户端"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="下载地址" min-width="220">
							<template slot-scope="scope">
								<el-input v-model="scope.row.url" size="mini" placeholder="https://... 或 #"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="版本" width="110">
							<template slot-scope="scope">
								<el-input v-model="scope.row.version" size="mini" placeholder="v4.0.0"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="说明" min-width="160">
							<template slot-scope="scope">
								<el-input v-model="scope.row.note" size="mini" placeholder="系统要求等"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="70" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="delSiteRow('downloads', scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header card-header-row">
						<span>App 界面展示图</span>
						<el-button type="primary" icon="el-icon-plus" size="small" @click="addSiteRow('shots')">新增展示图</el-button>
					</div>
					<el-alert type="info" :closable="false" style="margin-bottom:12px"
						title="配置后展示在官网「产品展示」区域下方,按列表顺序展示;留空则使用内置场景卡。图片URL可使用文件上传接口返回的地址。"></el-alert>
					<el-table :data="siteForm.shots" border size="small">
						<el-table-column label="标题" min-width="160">
							<template slot-scope="scope">
								<el-input v-model="scope.row.title" size="mini" placeholder="如:聊天界面"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="图片地址" min-width="320">
							<template slot-scope="scope">
								<el-input v-model="scope.row.imageUrl" size="mini" placeholder="https://...(竖屏截图效果最佳,建议 9:16)"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="70" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="delSiteRow('shots', scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header card-header-row">
						<span>应用案例展示</span>
						<el-button type="primary" icon="el-icon-plus" size="small" @click="addSiteRow('cases')">新增案例</el-button>
					</div>
					<el-table :data="siteForm.cases" border size="small">
						<el-table-column label="图标(emoji)" width="110">
							<template slot-scope="scope">
								<el-input v-model="scope.row.icon" size="mini" placeholder="💬"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="标题" min-width="150">
							<template slot-scope="scope">
								<el-input v-model="scope.row.title" size="mini"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="简介" min-width="260">
							<template slot-scope="scope">
								<el-input v-model="scope.row.summary" size="mini"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="配图URL" min-width="220">
							<template slot-scope="scope">
								<el-input v-model="scope.row.imageUrl" size="mini" placeholder="可空"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="70" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="delSiteRow('cases', scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header card-header-row">
						<span>H5 接入口（官网 H5 专区）</span>
						<el-button type="primary" icon="el-icon-plus" size="small" @click="addSiteRow('h5')">新增 H5 入口</el-button>
					</div>
					<el-alert type="info" :closable="false" style="margin-bottom:12px"
						title="配置后展示在官网「H5 专区」区块,按排序值升序展示;关闭启用则不显示。点击卡片在新标签打开对应 H5 页面。"></el-alert>
					<el-table :data="siteForm.h5" border size="small">
						<el-table-column label="标题" min-width="150">
							<template slot-scope="scope">
								<el-input v-model="scope.row.title" size="mini" placeholder="如:比特商城"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="跳转地址" min-width="300">
							<template slot-scope="scope">
								<el-input v-model="scope.row.url" size="mini" placeholder="https://... (H5 页面链接)"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="图标(emoji/图)" width="150">
							<template slot-scope="scope">
								<el-input v-model="scope.row.icon" size="mini" placeholder="💡 或图片URL"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="排序" width="90">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.sort" :min="0" :max="999" size="mini" controls-position="right" style="width:74px"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="启用" width="70" align="center">
							<template slot-scope="scope">
								<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" size="mini"></el-switch>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="70" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="delSiteRow('h5', scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>

				<el-card class="box-card" shadow="never" style="margin-top:16px">
					<div slot="header" class="card-header">
						<span>页脚信息</span>
					</div>
					<el-form :model="siteForm" label-width="120px" style="max-width:720px">
						<el-form-item label="ICP 备案号">
							<el-input v-model="siteForm.icp" maxlength="64" placeholder="如:京ICP备xxxxxxxx号(可空)"></el-input>
						</el-form-item>
						<el-form-item label="版权信息">
							<el-input v-model="siteForm.copyright" maxlength="128" placeholder="如:© 2026 比特IM"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" :loading="siteSaving" @click="saveSite">保存官网配置</el-button>
						</el-form-item>
					</el-form>
				</el-card>
			</el-tab-pane>

			<!-- 外链配置(推广管理) -->
			<el-tab-pane label="外链配置" name="promotion">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="card-header card-header-row">
						<span>推广 / 外链管理</span>
						<el-button type="primary" icon="el-icon-plus" size="small" @click="openPromoAdd">新增外链</el-button>
					</div>
					<el-alert type="info" :closable="false" style="margin-bottom:12px"
						title="配置后展示在客户端「我的」页面,按排序值升序展示,禁用的不显示。"></el-alert>
					<el-table :data="promoList" v-loading="promoLoading" border stripe>
						<el-table-column prop="id" label="ID" width="70"></el-table-column>
						<el-table-column prop="title" label="标题" min-width="130"></el-table-column>
						<el-table-column label="图标" width="80">
							<template slot-scope="scope">
								<el-image v-if="scope.row.image" :src="scope.row.image" style="width:32px;height:32px"
									fit="cover"></el-image>
								<span v-else class="muted">—</span>
							</template>
						</el-table-column>
						<el-table-column prop="url" label="跳转地址" min-width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="sort" label="排序" width="70"></el-table-column>
						<el-table-column label="状态" width="80">
							<template slot-scope="scope">
								<el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
									{{ scope.row.status === 1 ? '启用' : '禁用' }}
								</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
						<el-table-column label="操作" width="140" fixed="right">
							<template slot-scope="scope">
								<el-button size="mini" @click="openPromoEdit(scope.row)">编辑</el-button>
								<el-button size="mini" type="danger" @click="delPromo(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</el-tab-pane>
		</el-tabs>

		<!-- 外链新增/编辑对话框 -->
		<el-dialog :title="promoDialogTitle" :visible.sync="promoDialogVisible" width="520px" :close-on-click-modal="false">
			<el-form :model="promoForm" :rules="promoRules" ref="promoFormRef" label-width="90px">
				<el-form-item label="标题" prop="title">
					<el-input v-model="promoForm.title" maxlength="128" placeholder="推广标题"></el-input>
				</el-form-item>
				<el-form-item label="跳转地址" prop="url">
					<el-input v-model="promoForm.url" maxlength="1024" placeholder="https://..."></el-input>
				</el-form-item>
				<el-form-item label="图标地址">
					<el-input v-model="promoForm.image" maxlength="512" placeholder="图片URL(可空,空则前端显示默认)"></el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input v-model="promoForm.remark" maxlength="255" placeholder="仅管理端可见"></el-input>
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="promoForm.sort" :min="0" controls-position="right"></el-input-number>
				</el-form-item>
				<el-form-item label="状态">
					<el-switch v-model="promoForm.status" :active-value="1" :inactive-value="0"></el-switch>
					<span class="status-tip">启用后才会展示在客户端"我的"页面</span>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="promoDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitPromo">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import AdminApi from '../../api/adminApi.js'
import PromotionApi from '../../api/promotionApi.js'
const promoApi = new PromotionApi()

export default {
	data() {
		return {
			activeTab: 'basic',
			loading: false,
			saving: false,
			testing: false,
			testTo: '',
			sslBool: true,
			mailCodeBool: true,
			form: {
				projectName: '',
				logoUrl: '',
				emailHost: '',
				emailPort: '465',
				emailUsername: '',
				emailPassword: '',
				emailFrom: '',
				emailSsl: 'true',
				rentNotice: '',
				rentUrl: '',
				rentAddress: '',
				registerMailCodeRequired: 'true'
			},
			// 外链(推广)配置
			promoList: [],
			promoLoading: false,
			promoLoaded: false,
			promoDialogVisible: false,
			promoDialogTitle: '新增外链',
			promoForm: {
				id: null,
				title: '',
				url: '',
				image: '',
				remark: '',
				sort: 0,
				status: 1
			},
			promoRules: {
				title: [{
					required: true,
					message: '请输入标题',
					trigger: 'blur'
				}],
				url: [{
					required: true,
					message: '请输入跳转地址',
					trigger: 'blur'
				}]
			},
			// 官网配置
			siteLoading: false,
			siteSaving: false,
			siteLoaded: false,
			siteForm: {
				heroBadge: '',
				heroTitle: '',
				heroSubtitle: '',
				seoTitle: '',
				seoKeywords: '',
				seoDescription: '',
				serviceUrl: '',
				serviceWechat: '',
				serviceQq: '',
				servicePhone: '',
				serviceTime: '',
				downloads: [],
				stats: [],
				faq: [],
				cases: [],
				shots: [],
				h5: [],
				icp: '',
				copyright: ''
			}
		}
	},
	watch: {
		sslBool(val) {
			this.form.emailSsl = val ? 'true' : 'false'
		},
		mailCodeBool(val) {
			this.form.registerMailCodeRequired = val ? '1' : '0'
		},
		'$route.query.tab'(val) {
			if (val) {
				this.activeTab = val
			}
		}
	},
	created() {
		this.load()
		// 支持 /admin/system?tab=promotion 直达(旧外链管理入口重定向过来)
		const q = this.$route.query.tab
		if (q) {
			this.activeTab = q
		}
	},
	methods: {
		load() {
			this.loading = true
			new AdminApi().getConfig().then((cfg) => {
				if (cfg) {
					this.form.projectName = cfg.projectName || ''
					this.form.logoUrl = cfg.logoUrl || ''
					this.form.emailHost = cfg.emailHost || ''
					this.form.emailPort = cfg.emailPort || '465'
					this.form.emailUsername = cfg.emailUsername || ''
					this.form.emailFrom = cfg.emailFrom || ''
					this.form.emailPassword = '' // 不回显密码
					this.sslBool = (cfg.emailSsl === 'true' || cfg.emailSsl === true)
					this.form.emailSsl = this.sslBool ? 'true' : 'false'
					this.form.rentNotice = cfg.rentNotice || ''
					this.form.rentUrl = cfg.rentUrl || ''
					this.form.rentAddress = cfg.rentAddress || ''
					this.mailCodeBool = (cfg.registerMailCodeRequired === '1' || cfg.registerMailCodeRequired === true || cfg.registerMailCodeRequired === 'true')
					this.form.registerMailCodeRequired = this.mailCodeBool ? '1' : '0'
				}
			}).finally(() => {
				this.loading = false
			})
		},
		save() {
			this.saving = true
			new AdminApi().saveConfig(this.form).then(() => {
				this.$message.success('配置已保存')
				this.form.emailPassword = ''
			}).catch(() => {}).finally(() => {
				this.saving = false
			})
		},
		sendTest() {
			if (!this.testTo) {
				this.$message.warning('请填写接收邮箱')
				return
			}
			this.testing = true
			new AdminApi().testEmail(this.testTo).then((msg) => {
				this.$message.success(msg || '测试邮件已发送，请检查收件箱')
			}).catch(() => {}).finally(() => {
				this.testing = false
			})
		},
		// tab 点击:切到外链/官网时懒加载
		onTabClick(tab) {
			if (tab.name === 'promotion' && !this.promoLoaded) {
				this.loadPromoList()
			}
			if (tab.name === 'site' && !this.siteLoaded) {
				this.loadSite()
			}
		},
		async loadSite() {
			this.siteLoading = true
			try {
				const data = await new AdminApi().getSite()
				if (data) {
					this.siteForm = {
						heroBadge: data.heroBadge || '',
						heroTitle: data.heroTitle || '',
						heroSubtitle: data.heroSubtitle || '',
						seoTitle: data.seoTitle || '',
						seoKeywords: data.seoKeywords || '',
						seoDescription: data.seoDescription || '',
						serviceUrl: data.serviceUrl || '',
						serviceWechat: data.serviceWechat || '',
						serviceQq: data.serviceQq || '',
						servicePhone: data.servicePhone || '',
						serviceTime: data.serviceTime || '',
						downloads: data.downloads || [],
						stats: data.stats || [],
						faq: data.faq || [],
						cases: data.cases || [],
						shots: data.shots || [],
						h5: data.h5 || [],
						icp: data.icp || '',
						copyright: data.copyright || ''
					}
				}
				this.siteLoaded = true
			} catch (e) {
				// 错误提示由请求拦截器统一处理
			} finally {
				this.siteLoading = false
			}
		},
		saveSite() {
			this.siteSaving = true
			const payload = {
				...this.siteForm,
				// 品牌名/Logo 与基础配置保持同一数据源
				projectName: this.form.projectName,
				logoUrl: this.form.logoUrl
			}
			new AdminApi().saveSite(payload).then(() => {
				this.$message.success('官网配置已保存')
			}).catch(() => {}).finally(() => {
				this.siteSaving = false
			})
		},
		addSiteRow(list) {
			if (list === 'downloads') {
				this.siteForm.downloads.push({ platform: 'windows', name: '', url: '#', version: '', note: '' })
			} else if (list === 'shots') {
				this.siteForm.shots.push({ title: '', imageUrl: '' })
			} else if (list === 'cases') {
				this.siteForm.cases.push({ icon: '', title: '', summary: '', imageUrl: '' })
			} else if (list === 'h5') {
				this.siteForm.h5.push({ title: '', url: '', icon: '', sort: 0, status: 1 })
			} else if (list === 'stats') {
				this.siteForm.stats.push({ value: '', label: '' })
			} else if (list === 'faq') {
				this.siteForm.faq.push({ q: '', a: '' })
			}
		},
		delSiteRow(list, idx) {
			this.siteForm[list].splice(idx, 1)
		},
		async loadPromoList() {
			this.promoLoading = true
			try {
				this.promoList = await promoApi.listAll()
				this.promoLoaded = true
			} catch (e) {
				// 错误提示由请求拦截器统一处理
			} finally {
				this.promoLoading = false
			}
		},
		openPromoAdd() {
			this.promoForm = {
				id: null,
				title: '',
				url: '',
				image: '',
				remark: '',
				sort: 0,
				status: 1
			}
			this.promoDialogTitle = '新增外链'
			this.promoDialogVisible = true
			this.$nextTick(() => {
				this.$refs.promoFormRef && this.$refs.promoFormRef.clearValidate()
			})
		},
		openPromoEdit(row) {
			this.promoForm = {
				...row
			}
			this.promoDialogTitle = '编辑外链'
			this.promoDialogVisible = true
			this.$nextTick(() => {
				this.$refs.promoFormRef && this.$refs.promoFormRef.clearValidate()
			})
		},
		submitPromo() {
			this.$refs.promoFormRef.validate(async (valid) => {
				if (!valid) return
				try {
					if (this.promoForm.id) {
						await promoApi.update(this.promoForm)
						this.$message.success('修改成功')
					} else {
						await promoApi.add(this.promoForm)
						this.$message.success('新增成功')
					}
					this.promoDialogVisible = false
					this.loadPromoList()
				} catch (e) {
					/* 失败由请求拦截器统一提示 */
				}
			})
		},
		delPromo(row) {
			this.$confirm(`确认删除外链"${row.title}"?`, '提示', {
				type: 'warning'
			}).then(async () => {
				try {
					await promoApi.del(row.id)
					this.$message.success('已删除')
					this.loadPromoList()
				} catch (e) {
					/* 失败由请求拦截器统一提示 */
				}
			}).catch(() => {})
		}
	}
}
</script>

<style scoped>
.config-page {
	padding: 4px;

	.box-card {
		border-radius: 8px;
	}

	.card-header {
		font-weight: 600;
	}

	.card-header-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.form-tip {
		font-size: 12px;
		color: #909399;
		line-height: 1.6;
		margin-top: 4px;
	}

	.status-tip {
		font-size: 12px;
		color: #909399;
		margin-left: 10px;
	}

	.muted {
		color: #c0c4cc;
	}
}
</style>
